import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ResponseReader } from './response-reader.service';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    //API Paquete Fiscal 2020 INICIATIVAS
    urlPFiscal_iniciativas = 'http://congresoyucatan.gob.mx/vistas/paqueteFiscal2019/api/pFiscalCategorias.php?id_categoria=1';
    //API Paquete Fiscal 2020 DICTAMENES
    urlPFiscal_dictamentes = 'http://congresoyucatan.gob.mx/vistas/paqueteFiscal2019/api/pFiscalCategorias.php?id_categoria=2';
    //API Paquete Fiscal 2020 DECRETOS
    urlPFiscal_decretos = 'http://congresoyucatan.gob.mx/vistas/paqueteFiscal2019/api/pFiscalCategorias.php?id_categoria=3';

    // Subject para emitir un evento cuando se cambie la legislatura
    private cambioLegislatura = new Subject<void>();
    public cambioLegislatura$ = this.cambioLegislatura.asObservable();

    // Para almacenar la legislatura actual

    private legislaturaActual: any;

    // El url del API, se obtiene desde el archivo environment

    private apiUrl = environment.publicApi;

    constructor(private _http: HttpClient, public reader: ResponseReader) { }

    //Lista todas las iniciativas del Paquete Fiscal
    getIniciativaPFiscalAPI_iniciativas(): Observable<any> {
        return this._http.get<any>(this.urlPFiscal_iniciativas);
      }
    //Lista todas los dictamenes del Paquete Fiscal
    getIniciativaPFiscalAPI_dictamenes(): Observable<any> {
        return this._http.get<any>(this.urlPFiscal_dictamentes);
      }
    //Lista todas los decretos del Paquete Fiscal
    getIniciativaPFiscalAPI_decretos(): Observable<any> {
        return this._http.get<any>(this.urlPFiscal_decretos);
      }

    /**
     * Crea un objeto de tipo HttpHeaders
     * en el cual en caso de existir un token en localstorage, lo añadirá
     * al final retorna el header
     */

    public setAuthorizationHeader(): HttpHeaders {
        let headers = new HttpHeaders();
        let token = window.localStorage.getItem(environment.localStorage_token_name);
        if (token) {
            headers = headers.set('authorization', token);
        }
        return headers;
    }

    /**
     * Realiza una petición HTTP a la URL que se indique en el parámetro
     * Retorna un observable por defecto
     * @param url: string
     */
    public get(url) {
        let headers = this.setAuthorizationHeader();
        return this._http.get(this.apiUrl + url, { headers })
    }

    /**
     * Realizar una petición tipo get a la dirección recibida
     * @param url de tipo string -> Dirección de un api tipo GET
     */
    public freeGet(url) {
        return this._http.get(url)
    }

    /**
     * Realiza una petición tipo POST al API a la dirección URL recibida
     * @param url del API
     * @param json tipo objeto que será enviado al API
     */
    public post(url, json) {
        let headers = this.setAuthorizationHeader();
        return this._http.post(this.apiUrl + url, json, { headers })
    }

    /**
     * Establece la legislatura y emite el evento
     * @param l : el objeto de la legislatura
     */
    public setLegislatura(l) {
        this.legislaturaActual = l;
        this.cambioLegislatura.next();
    }

    /**
     * Retorna la legislatura
     */
    public getLegislatura() {
        return this.legislaturaActual;
    }

    /**
     * Retorna un string que es el token del usuario
     * puede retornar el token o null, hay que verificarlo
     * y si el localstorage no está disponible debe mostrar un mensaje
     * para el usuario indicando que su navegador no lo soporta
     * 
     */
    public obtenerToken() {
        if (window.localStorage) {
            return window.localStorage.getItem(environment.localStorage_token_name);
        }
    }

    /**
     * Almacena en el localstorage el token
     * @param token de tipo string
     * 
     * Si el token no es válido o el navegador no soporta el almacenamiento
     * debe mostrarle al usuario un mensaje 
     */
    public establecerToken(token) {
        if (token && window.localStorage) {
            window.localStorage.setItem(environment.localStorage_token_name, token);
        }
    }
}
